import { getLocale } from '../../services/storageService/GlobalData';
import {
  CUSTOM_PERFORMANCE,
  FEEDLOT_RANK,
  LOCAL_STORAGE_KEYS,
} from '../../constants/AppConstants';
import { setLocalstorageItem } from '.';

class OptionsManager {
  //#region getLoggedinUser
  getLoggedinUser() {
    let user = {
      token: this.getToken(),
      userId: parseInt(this.getLoggedinUserId(), 10),
      pinCode: this.getPinCode(), //need to encrypt
      userName: this.getLoggedinUserName(),
      userEmail: this.getLoggedinUserEmail(),
      userFullName: this.getLoggedinUserFullName(),
      userRoleId: parseInt(this.getLoggedinUserRoleId(), 10),
      userRoleName: this.getLoggedinUserRoleName(),
      userEmailAlerts: this.getLoginUserEmailAlerts(),
    };

    return user;
  }
  //#endregion

  //#region islogin
  isLogin() {
    const isLogin = localStorage.getItem('isLogin');
    return isLogin;
  }

  saveIsLogin(value) {
    setLocalstorageItem('isLogin', value);
    return true;
  }
  //#endregion

  //#region isLocked
  isLocked() {
    const isLocked = localStorage.getItem('isLocked');
    return isLocked;
  }

  saveIsLocked(value) {
    setLocalstorageItem('isLocked', value);
    return true;
  }
  //#endregion

  //#region Token
  getToken() {
    const token = localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
    return token;
  }

  saveToken(value) {
    setLocalstorageItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN, value);
    return value;
  }
  //#endregion

  //#region loggedinUserId
  getLoggedinUserId() {
    const loggedinUserId = localStorage.getItem('loggedinUserId');
    return loggedinUserId;
  }

  saveLoggedinUserId(value) {
    setLocalstorageItem('loggedinUserId', value);
    return value;
  }
  //#endregion

  //#region pinCode
  getPinCode() {
    const pinCode = localStorage.getItem('pinCode');
    return pinCode;
  }

  savePinCode(value) {
    setLocalstorageItem('pinCode', value);
    return value;
  }
  //#endregion

  //#region loggedinUserName
  getLoggedinUserName() {
    const loggedinUserName = localStorage.getItem('loggedinUserName');
    return loggedinUserName;
  }

  saveLoggedinUserName(value) {
    setLocalstorageItem('loggedinUserName', value);
    return value;
  }

  //#region loggedinUserEmailAlerts
  getLoginUserEmailAlerts() {
    const emailAlerts = localStorage.getItem('loggedinUserEmailAlerts');
    return emailAlerts;
  }

  saveLoggedinUserEmailAlerts(value) {
    setLocalstorageItem('loggedinUserEmailAlerts', value);
    return value;
  }
  //#endregion

  //#region loggedinUserEmail
  getLoggedinUserEmail() {
    const loggedinUserEmail = localStorage.getItem('loggedinUserEmail');
    return loggedinUserEmail;
  }

  saveLoggedinUserEmail(value) {
    setLocalstorageItem('loggedinUserEmail', value);
    return value;
  }
  //#endregion

  //#region loggedinUserFullName
  getLoggedinUserFullName() {
    const loggedinUserFullName = localStorage.getItem('loggedinUserFullName');
    return loggedinUserFullName;
  }

  saveLoggedinUserFullName(value) {
    setLocalstorageItem('loggedinUserFullName', value, true);
    return value;
  }
  //#endregion

  //#region loggedinUserRoleId
  getLoggedinUserRoleId() {
    const loggedinUserRoleId = localStorage.getItem('loggedinUserRoleId');
    return loggedinUserRoleId;
  }

  saveLoggedinUserRoleId(value) {
    setLocalstorageItem('loggedinUserRoleId', value);
    return value;
  }
  //#endregion

  //#region loggedinUserRoleName
  getLoggedinUserRoleName() {
    const loggedinUserRoleName = localStorage.getItem('loggedinUserRoleName');
    return loggedinUserRoleName;
  }

  saveLoggedinUserRoleName(value) {
    setLocalstorageItem('loggedinUserRoleName', value);
    return value;
  }

  //#endregion

  //#region lastNotificationSyncTime
  getLastNotifcationSyncTime() {
    const time = localStorage.getItem('lastNotifcationSyncTime');
    return time ? time : 0;
  }

  saveLastNotificationSyncTime(value) {
    setLocalstorageItem('lastNotifcationSyncTime', value);
    return value;
  }
  //#endregion

  //#region save & get notification count
  getNotifcationCount() {
    const count = localStorage.getItem('notificationCount');
    return count ? count : 0;
  }

  saveNotifcationCount(value) {
    setLocalstorageItem('notificationCount', value);
    return value;
  }
  //#endregion

  //#region save & get language set

  getLanguage() {
    const language = localStorage.getItem('language');
    return language;
  }

  saveLanguage() {
    let value = getLocale();
    setLocalstorageItem('language', value);
    return value;
  }
  //#endregion
  getFeedlotRank() {
    var rankObj = {
      count: 0,
      position: 0,
      performance: 0,
    };

    try {
      const count = localStorage.getItem(FEEDLOT_RANK.COUNT);
      rankObj.count = count ? count : 0;

      const position = localStorage.getItem(FEEDLOT_RANK.POSITION);
      rankObj.position = position ? position : 0;

      const performance = localStorage.getItem(FEEDLOT_RANK.PERFORMANCE);
      rankObj.performance = performance ? performance : 0;

      return rankObj;
    } catch (e) {
      return rankObj;
    }
  }

  saveFeedlotRank(count, ranks) {
    try {
      let rank_count = {
        key: FEEDLOT_RANK.COUNT,
        value: String(count),
      };
      let rank_position = {
        key: FEEDLOT_RANK.POSITION,
        value: String(ranks && ranks.length > 0 ? ranks[0].rank.position : 0),
      };
      let rank_performance = {
        key: FEEDLOT_RANK.PERFORMANCE,
        value: String(
          ranks && ranks.length > 0 ? ranks[0].rank.performance : 0,
        ),
      };

      setLocalstorageItem(rank_count.key, rank_count.value);
      setLocalstorageItem(rank_position.key, rank_position.value);
      setLocalstorageItem(rank_performance.key, rank_performance.value);

      return true;
    } catch (e) {
      console.log('saveFeedlotRanksaveFeedlotRank', e);
      return false;
    }
  }

  //#region coachmark status
  getFirstLogin() {
    const data = localStorage.getItem('isFirstLogin');
    return data === 'true';
  }

  setFirstLogin(data) {
    setLocalstorageItem('isFirstLogin', data.value);
    return data.value === 'true';
  }
  //#endregion

  //#region slectedFeedyard
  getSelectedFeedyard() {
    const data = localStorage.getItem('selectedFeedyard');
    return data;
  }

  setSelectedFeedyard(value) {
    try {
      setLocalstorageItem('selectedFeedyard', value);
      return value;
    } catch (e) {
      return false;
    }
  }
  //#endregion

  getCustomPerformanceFilter() {
    let customPerformanceObj = {};

    try {
      const performance = localStorage.getItem(CUSTOM_PERFORMANCE.PERFORMANCE);
      customPerformanceObj.performance = performance ? performance : 0;

      const startDate = localStorage.getItem(CUSTOM_PERFORMANCE.START_DATE);
      customPerformanceObj.startDate = startDate ? startDate : null;

      const endDate = localStorage.getItem(CUSTOM_PERFORMANCE.END_DATE);
      customPerformanceObj.endDate = endDate ? endDate : null;

      const activities = localStorage.getItem(CUSTOM_PERFORMANCE.ACTIVITIES);
      customPerformanceObj.activities = activities
        ? JSON.parse(activities)
        : [];

      return customPerformanceObj;
    } catch (e) {
      console.log('getCustomPerformanceFilter fail', e);
      return customPerformanceObj;
    }
  }

  saveCustomPerformanceFilter(performance, start, end, feedlot_activites) {
    try {
      setLocalstorageItem(CUSTOM_PERFORMANCE.PERFORMANCE, String(performance));
      setLocalstorageItem(CUSTOM_PERFORMANCE.START_DATE, String(start));
      setLocalstorageItem(CUSTOM_PERFORMANCE.END_DATE, String(end));
      setLocalstorageItem(
        CUSTOM_PERFORMANCE.ACTIVITIES,
        JSON.stringify(feedlot_activites),
      );

      return true;
    } catch (e) {
      console.log('saveCustomPerformanceFilter fail', e);
      return false;
    }
  }

  setFeedyardChangeEvent() {
    setLocalstorageItem(
      LOCAL_STORAGE_KEYS.FEEDYARD_CHANGED_AT,
      Date.now().toString(),
    );
    return true;
  }

  getFeedYardChangeEvent(value) {
    try {
      const data = localStorage.getItem(LOCAL_STORAGE_KEYS.FEEDYARD_CHANGED_AT);
      return data;
    } catch (e) {
      return false;
    }
  }
}

export default new OptionsManager();
